import {parsePhoneNumberWithError} from 'libphonenumber-js/mobile';

export const isValidUKMobile = (number) => {
  if (!number) return false;

  try {
    const phoneNumber = parsePhoneNumberWithError(number, {defaultCountry: 'GB'});
    return phoneNumber.isValid() &&
      phoneNumber.country === 'GB' &&
      phoneNumber.getType() === 'MOBILE';
  } catch (error) {
    console.error('Phone validation error:', error);
    return false;
  }
};
